// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {CalendarIntegrationModel} from '@supermove/models';

// App
import DeleteModal from '@shared/design/components/Modal/SmallModal/DeleteModal';
import useDeleteCalendarIntegrationMutation from '@shared/modules/AccountCalendar/hooks/useDeleteCalendarIntegrationMutation';

interface DeleteCalendarIntegrationModalProps {
  calendarIntegration: CalendarIntegrationModel;
  isOpen: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

const DeleteCalendarIntegrationModal = ({
  calendarIntegration,
  isOpen,
  handleClose,
  onSuccess,
}: DeleteCalendarIntegrationModalProps) => {
  const {submitting, handleSubmit} = useDeleteCalendarIntegrationMutation({
    calendarIntegrationId: _.toNumber(calendarIntegration.id),
    onSuccess: () => {
      handleClose();
      onSuccess?.();
    },
    onError: (errors) => {
      console.error({errors});
    },
  });

  return (
    <DeleteModal
      isOpen={isOpen}
      handleClose={handleClose}
      handleDelete={handleSubmit}
      title={`Delete integration for "${calendarIntegration.accountCalendar.calendarName}"?`}
      subtitle={
        'Removing the integration will not affect any exported events. This action cannot be undone.'
      }
      deleteButtonText={'Delete Integration'}
      cancelButtonText={'Cancel'}
      isSubmitting={submitting}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
DeleteCalendarIntegrationModal.fragment = gql`
  fragment DeleteCalendarIntegrationModal on CalendarIntegration {
    id
    accountCalendar {
      id
      calendarName
    }
  }
`;

export default DeleteCalendarIntegrationModal;
